import { render, staticRenderFns } from "./AddonGdpr.vue?vue&type=template&id=42e492a3&scoped=true&"
import script from "./AddonGdpr.vue?vue&type=script&lang=js&"
export * from "./AddonGdpr.vue?vue&type=script&lang=js&"
import style0 from "./AddonGdpr.vue?vue&type=style&index=0&id=42e492a3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e492a3",
  null
  
)

export default component.exports